module.exports = __webpack_public_path__ + "img/Women and Investing Infographic.ba3ac9ae.png";